import { render, staticRenderFns } from "./OrderNotificationToggle.vue?vue&type=template&id=78f861d2&scoped=true&"
import script from "./OrderNotificationToggle.vue?vue&type=script&lang=js&"
export * from "./OrderNotificationToggle.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotificationToggle.vue?vue&type=style&index=0&id=78f861d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f861d2",
  null
  
)

export default component.exports